var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.765,
    height: 40.765,
    viewBox: "0 0 40.765 40.765",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.679,983.745a20.383,20.383,0,1,1,20.383,20.383A20.4,20.4,0,0,1,8.679,983.745Zm2.091,0a18.292,18.292,0,1,0,18.292-18.292A18.276,18.276,0,0,0,10.77,983.745Zm4.7,0a1.214,1.214,0,0,1,.294-.719l8.362-8.885a1.046,1.046,0,0,1,1.519,1.438L18.936,982.7H41.6a1.045,1.045,0,0,1,0,2.091H18.936l6.713,7.121a1.105,1.105,0,0,1-.032,1.486,1.057,1.057,0,0,1-1.486-.049l-8.362-8.885a.928.928,0,0,1-.294-.719Z",
    transform: "translate(-8.679 -963.362)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back_arrow.5bc704901b8d97e8c404bf602bd127d2.svg";
export { ForwardRef as ReactComponent };